import React, { Fragment, useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Container,
  Grid,
  Link,
  Typography
} from '@material-ui/core';
import BuildIcon from '@material-ui/icons/BuildOutlined';
import DriveEtaOutlinedIcon from '@material-ui/icons/DriveEta';
import PlaceIcon from '@material-ui/icons/PlaceOutlined';
import Finance from "../shared/FinanceCalulator";
import FacebookSocial from '../shared/assets/facebook.png';
import TwitterSocial from '../shared/assets/twitter.png';
import InstagramSocial from '../shared/assets/instagram.png';
import YouTubeSocial from '../shared/assets/youtube.png';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex'
  },
  container: {
    marginTop: '0px',
    marginBottom: '33px',
  },
  containerfooter: {
    marginTop: '0px',
    marginBottom: '33px',
    padding: '0px 50px',
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 959px)': {
      padding: '0px 20px',
      justifyContent: 'unset',
    },
    "& h6": {
      textTransform: "capitalize"
    }
  },
  iconsWrapper: {
    height: 120,
  },
  icons: {
    display: 'flex',
  },
  icon: {
    width: 48,
    height: 48,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    color: '#000000'
  },
  list: {
    margin: 0,
    listStyle: 'none',
    padding: 0,
  },
  listbottom: {
    margin: 0,
    listStyle: 'none',
    padding: 0,
    display: 'flex',
  },
  background: {
    backgroundColor: '#000000',
    display: 'flex',
    margin: 0,
    listStyle: 'none',
    padding: '10px 5%',
    maxWidth: 'unset',
  },
  listbottom: {

    display: 'flex',
    margin: 0,
    listStyle: 'none',
    padding: '10px 20px',

  },
  bottomlistItem: {
    paddingRight: theme.spacing(2),
    cursor: 'pointer',

  },
  listItem: {
    cursor: 'pointer',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  language: {
    marginTop: theme.spacing(1),
    width: 150,
  },
  footerIconSection: {
    backgroundColor: '#000000'
  },
  footerIconSectionLink: {
    color: '#ffffff',
    textTransform: "capitalize"
  },
  footerIconSectionIcon: {
    color: '#EFDF00'
  },
  footerLink: {
    color: '#7c7c7c!important',
    textTransform: "capitalize"
  },
  mb: {
    marginRight: '10px'
  },
  stickyBarInner: {
    backgroundColor: "#F8F8F8",
    textAlign: "center",
    position: "fixed",
    left: "0",
    bottom: "0",
    height: "60px",
    width: "100%",
  },
  stickyBar: {
    display: 'block',
    padding: '20px',
    height: '60px',
    width: '100%'
  },
  stickyBarImage: {
    width: '100%',
    height: '100%'
  },
  borderTop: {
    borderTop: '1px black solid',
    padding: '5px 10px',
    '@media (max-width: 425px)': {
      display: 'flex',
      flexDirection: 'column-reverse',
    }

  },
  calcHolder: {
    position: 'fixed',
    top: '0',
    background: '#9095a0a8',
    zIndex: '20',
    width: "100%",
    height: "100%",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
}));

export default function FooterComponent() {

  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const openCalc = () => {

    setOpen(!open);

  }

  return (
    <Fragment>
      {
        open &&
        <div className={classes.calcHolder}>
          <Finance openCalc={setOpen} />
        </div>
      }
      <Box className={classes.footerIconSection} style={{ marginTop: '15px' }}>
        <Container maxWidth={false} className={classes.container}>
          <Grid container spacing={5} className={classes.footerIconSection}>
            <Grid item xs={12} sm={6} md={3} align="center">
              <Link className={classes.footerLink} href="/pre-loved">
                <Box mb={2}>
                  <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '3.5rem' }} stroke="none" fill="currentColor" viewBox="0 0 30 30">

                    <path d="M22.623 13.05c.157.484.32.985.204 1.3-.116.315-.56.582-.989.838-.427.258-.87.524-1.179.922-.323.414-.484.926-.64 1.421-.15.474-.304.964-.557 1.134-.221.15-.738.126-1.248.077-.557-.056-1.104-.078-1.516.038-.488.138-.905.453-1.308.757-.389.292-.79.594-1.101.594v.635l-.023-.635c-.137-.006-.294-.088-.456-.204l-.02-.049-.032.013a6.909 6.909 0 01-.514-.435c-.386-.349-.786-.709-1.28-.9-.45-.174-.93-.189-1.424-.189l-.23.001c-.455 0-.881-.014-1.089-.184-.247-.203-.357-.712-.462-1.206-.108-.501-.22-1.02-.496-1.453-.282-.44-.706-.753-1.116-1.055-.397-.293-.807-.596-.89-.901-.08-.298.12-.771.313-1.228.201-.477.41-.972.434-1.501.022-.51-.139-1.007-.295-1.49-.156-.483-.319-.984-.202-1.299.115-.315.56-.582.989-.84.426-.256.868-.522 1.18-.919.321-.414.483-.926.639-1.422.149-.473.303-.963.555-1.133.222-.15.738-.127 1.249-.077.558.055 1.106.077 1.516-.038.488-.139.905-.454 1.31-.758.386-.291.787-.593 1.12-.593h.002c.29.014.662.35 1.023.675.386.348.785.709 1.279.9.451.174.95.188 1.422.188h.234c.454 0 .88.014 1.087.184.247.202.357.712.463 1.206.107.501.219 1.02.496 1.453.28.438.705.752 1.115 1.054.397.294.807.596.889.902.08.297-.12.77-.312 1.227-.202.477-.41.972-.434 1.502-.023.51.139 1.007.294 1.488zm-2.38 13.555l-1.617-.448a.61.61 0 00-.683.27l-.978 1.559-2.583-6.598c.675-.038 1.242-.451 1.742-.828.313-.235.637-.48.904-.556.154-.044.385-.045.633-.032l2.582 6.633zm-7.498-1.12l-.92-1.435a.61.61 0 00-.687-.262l-1.74.503 1.615-4.639c.192.014.371.038.515.093.282.109.594.39.897.664.116.106.238.215.362.32l.858 2.19-.9 2.566zM23.567 11.62c.014-.298.176-.684.334-1.057.265-.628.565-1.34.37-2.069-.199-.737-.816-1.192-1.36-1.595-.319-.235-.649-.478-.804-.721-.152-.237-.239-.639-.322-1.029-.145-.676-.31-1.442-.9-1.925-.563-.462-1.313-.462-1.86-.462h-.234c-.373 0-.73-.008-.986-.106-.28-.109-.594-.392-.896-.664-.496-.448-1.059-.957-1.865-.993-.719 0-1.311.446-1.834.841-.314.236-.637.48-.904.555-.243.07-.67.039-1.069-.001-.267-.025-.533-.05-.788-.05-.33 0-.82.033-1.26.33-.616.415-.85 1.154-1.054 1.805-.122.387-.247.786-.428 1.018-.167.215-.493.41-.838.617-.587.353-1.252.752-1.523 1.488-.27.736-.027 1.486.187 2.147.126.39.245.758.233 1.031-.014.298-.177.683-.334 1.056-.265.628-.565 1.34-.37 2.07.2.736.816 1.192 1.36 1.594.32.235.65.48.804.722.153.236.238.639.322 1.028.145.677.31 1.442.9 1.925.376.31.834.405 1.261.439l-1.883 5.41a.645.645 0 00.132.646.608.608 0 00.621.178l2.46-.712 1.353 2.107a.614.614 0 00.591.282.625.625 0 00.51-.416l.847-2.417 1.922 4.908a.622.622 0 00.576.399c.209 0 .406-.11.52-.292l1.382-2.204 2.377.659a.612.612 0 00.625-.19c.156-.18.199-.435.112-.659l-2.826-7.262c.32-.011.733-.068 1.116-.325.617-.416.849-1.154 1.054-1.805.122-.387.248-.787.43-1.02.166-.214.492-.41.838-.618.586-.351 1.25-.75 1.52-1.486.271-.737.028-1.486-.186-2.148-.126-.389-.245-.756-.233-1.03zm-4.278 1.11a4.405 4.405 0 01-4.104 2.842 4.336 4.336 0 01-1.543-.283 4.35 4.35 0 01-2.448-2.295 4.354 4.354 0 01-.11-3.354A4.407 4.407 0 0115.187 6.8a4.36 4.36 0 011.544.283 4.35 4.35 0 012.448 2.294 4.354 4.354 0 01.11 3.355m-2.266-6.556a5.288 5.288 0 00-1.872-.343 5.342 5.342 0 00-4.974 3.444 5.282 5.282 0 00.132 4.066 5.285 5.285 0 002.969 2.782 5.316 5.316 0 001.871.342c2.2 0 4.2-1.384 4.974-3.443a5.282 5.282 0 00-.132-4.066 5.281 5.281 0 00-2.968-2.782" id="a" className={classes.footerIconSectionIcon}></path></svg>
                </Box>
                <Typography className={classes.footerIconSectionLink} style={{ fontWeight: 'bold' }}>certified vehicles</Typography>
                <Typography className={classes.footerIconSectionLink}>pre-owned & checked</Typography>
              </Link>

            </Grid>
            <Grid item xs={12} sm={6} md={3} align="center">
              <Link className={classes.footerLink} href="/our-dealers">
                <Box mb={2}><BuildIcon className={classes.footerIconSectionIcon} style={{ fontSize: '3.5rem' }} /></Box>
                <Typography className={classes.footerIconSectionLink} style={{ fontWeight: 'bold' }}>dedicated service centres</Typography>
                <Typography className={classes.footerIconSectionLink}>state-of-art infrastructure</Typography>
              </Link>
            </Grid>
            <Grid item xs={12} sm={6} md={3} align="center">
              <Link className={classes.footerLink} href="/special-offers">
                <Box mb={2}><DriveEtaOutlinedIcon className={classes.footerIconSectionIcon} style={{ fontSize: '3.5rem' }} /></Box>
                <Typography className={classes.footerIconSectionLink} style={{ fontWeight: 'bold' }}>special deals</Typography>
                <Typography className={classes.footerIconSectionLink}>current certified offers</Typography>
              </Link>
            </Grid>
            <Grid item xs={12} sm={6} md={3} align="center">
              <Link className={classes.footerLink} href="/our-dealers">
                <Box mb={2}><PlaceIcon className={classes.footerIconSectionIcon} style={{ fontSize: '3.5rem' }} /></Box>
                <Typography className={classes.footerIconSectionLink} style={{ fontWeight: 'bold' }}>nationwide</Typography>
                <Typography className={classes.footerIconSectionLink}>find a dealer</Typography>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Typography component="footer" className={classes.root}>
        <Container maxWidth={false}  >
          <Grid container spacing={5} className={classes.containerfooter}>
            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="h6" marked="left" gutterBottom>
                Legal
              </Typography>
              <ul className={classes.list}>
                <li className={classes.listItem}>
                  <Link className={classes.footerLink} href="/requestergws">POPIA</Link>
                </li>
                <li className={classes.listItem}>
                  <Link className={classes.footerLink} href="/terms">Terms and Conditions</Link>
                </li>
                <li className={classes.listItem}>
                  <Link className={classes.footerLink} href="/cookies">Cookie Policy</Link>
                </li>
              </ul>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="h6" marked="left" gutterBottom>
                Renault tools
              </Typography>
              <ul className={classes.list}>

                <li className={classes.listItem}>
                  <Link className={classes.footerLink} href="/pre-loved">search pre-owned vehicles</Link>
                </li>

                <li className={classes.listItem}>
                  <Link className={classes.footerLink} href="/special-offers">special deals</Link>
                </li>

              </ul>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="h6" marked="left" gutterBottom>
                owning a Renault
              </Typography>
              <ul className={classes.list}>
                <li className={classes.listItem}>
                  <Link className={classes.footerLink} href="https://renault-connect.renault.co.za/">easy connect</Link>
                </li>
              </ul>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="h6" marked="left" gutterBottom>
                financial services
              </Typography>
              <ul className={classes.list}>
                <li className={classes.listItem}>
                  <Link className={classes.footerLink} onClick={() => { openCalc() }}>finance calculator</Link>
                </li>

              </ul>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <Typography variant="h6" marked="left" gutterBottom>
                connect socially
              </Typography>
              <Link className={classes.footerLink} href="https://www.facebook.com/RSARenaultSelection">
                <img src={FacebookSocial} style={{ width: '40px', margin: '0.5rem' }} />
              </Link>
              <Link className={classes.footerLink} href="http://twitter.com/renault_sa">
                <img src={TwitterSocial} style={{ width: '40px', margin: '0.5rem' }} />
              </Link>
              <Link className={classes.footerLink} href="https://instagram.com/renault_sa">
                <img src={InstagramSocial} style={{ width: '40px', margin: '0.5rem' }} />
              </Link>
              <Link className={classes.footerLink} href="https://youtube.com/renaultsouthafrica">
                <img src={YouTubeSocial} style={{ width: '40px', margin: '0.5rem' }} />
              </Link>
            </Grid>

          </Grid>

        </Container>

      </Typography>

      <Container maxWidth={false} className={`${classes.listbottom} ${classes.borderTop}`} xs={12} sm={12} md={12}>
        <Grid item xs={12} sm={6} md={4} className={classes.footerLink} >
          {`© ${new Date().getFullYear()} all rights reserved -  Renault Selection`}
        </Grid>
        <Grid item xs={12} sm={6} md={5} align='end'>
          <Link variant="button" color="textSecondary" component={RouterLink} to='/cookies' className={classes.link}>
            cookie policy
          </Link>
          <span style={{ padding: '0px 10px' }}>|</span>
          <Link variant="button" color="textSecondary" component={RouterLink} to='/privacy' className={classes.link}>
            privacy policy
          </Link>
          <span style={{ padding: '0px 10px' }}>|</span>
          <Link variant="button" color="textSecondary" component={RouterLink} to='/terms' className={classes.link}>
            terms of use
          </Link>
        </Grid>

      </Container>
    </Fragment>
  );
}
